<template>
  <BaseTooltip v-editable :placement="placement">
    <template #label>
      <StoryblokComponent
        v-for="childBlok in blok.label"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </template>
    <template #content>
      <StoryblokComponent
        v-for="childBlok in blok.content"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </template>
  </BaseTooltip>
</template>

<script lang="ts" setup>
import type { SbTooltipStoryblok } from '@/types'

interface Props {
  blok: SbTooltipStoryblok
}

const props = defineProps<Props>()
const placement = computed(() => {
  return props.blok.position
})
</script>
